/* Copyright (C) 2021 ev-i Informationstechnologie GmbH */

export enum PlotMargin {
    NO_FOLD = "Nicht falten",
    FOLD_20MM_EDGE = "Falten mit 20mm Heftrand",
    FOLD_WITHOUT_EDGE = "Falten ohne Heftrand"
}
